import { Dedupe as DedupeIntegration } from '@sentry/integrations'
const isDev = process.env.NODE_ENV !== 'production'

export const sentrySettings = {
  dsn: 'https://7fa485182fa5414391f8bd15951852b4@sentry.io/5175308',
  //Instruct the SDK to never send an error to Sentry if it matches any
  // of the listed error messages. If no message is available, the SDK
  // will try to compare against an underlying exception type and value.
  ignoreErrors: [
    // This error gets reported by our ad injection on devices that block ads by
    // default as well as ad blockers and people with higher security settings
    // turn on in their browsers.
    /SecurityError: Blocked a frame with origin/,
    // Timeout rejection errors also occur with some of the ad injection.  We are
    // not blocking all unhandled rejections here, just for a timeout scenario
    'UnhandledRejection: Non-Error promise rejection captured with value: Timeout',
    // These are routine errors that can be safely ignored.  They can occur
    // when users navigate away from a page during a fetch.  We can capture
    // more meaningful errors in our try/catch blocks
    'TypeError: Failed to fetch',
    'TypeError: NetworkError when attempting to fetch resource.',
    // firefox-only, add-on error. was appearing with a high volume
    // across only ~30 users
    "can't access dead object" //eslint-disable-line quotes
  ],
  integrations: [new DedupeIntegration()],
  whitelistUrls: ['assets.getpocket.com/web-discover'],
  release: process.env.BUILD_ID,
  environment: isDev ? 'Development' : 'Production'
}
